import React, { FC, useState } from "react";
import { X, Send, Paperclip } from "lucide-react";

interface ChatVendorProp {
  isOpen: boolean;
  onClose: any;
}

const ChatVendor: FC<ChatVendorProp> = ({ isOpen, onClose }) => {
  const [messages, setMessages] = useState([
    {
      sender: "other",
      text: "I bought a package from CM Hair and she delivered a wrong package.",
    },
    {
      sender: "you",
      text: "Okay, send your Contract ID. Let me confirm the product.",
    },
    { sender: "other", text: "Okay." },
    { sender: "other", file: "Wild Payment Invoice.pdf", size: "1.2 MB" },
    { sender: "you", text: "..." },
  ]);

  const handleSendMessage = (text: string) => {
    setMessages([...messages, { sender: "you", text }]);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-end justify-end bg-black bg-opacity-50 z-50">
      <div className="bg-white w-full max-w-md h-full rounded-lg shadow-lg flex flex-col">
        {/* Header */}
        <div className="flex justify-between items-center p-4 border-b border-gray-200">
          <h2 className="text-lg font-semibold">Chat</h2>
          <button onClick={onClose}>
            <X className="w-5 h-5 text-gray-600" />
          </button>
        </div>

        {/* date */}
        <div className="my-10 flex text-lg text-gray-600 items-center justify-center font-bold w-full">
          Thursday, 23 Jun
        </div>

        {/* Chat Area */}
        <div className="flex-1 overflow-y-auto p-4 space-y-4 bg-gray-50">
          {messages.map((msg, index) => (
            <div
              key={index}
              className={`flex gap-4 ${
                msg.sender === "you" ? "justify-end" : "justify-start"
              }`}
            >
              <img src="/assets/images/svg/avatar.svg" alt="" />
              <div className="flex flex-col gap-2">
                <div className="flex items-center justify-between text-xs gap-6">
                  <span className="font-bold">
                    {msg.sender === "you" ? "You" : msg.sender}
                  </span>
                  <span>11:40am</span>
                </div>
                <div
                  className={`${
                    msg.sender === "you"
                      ? "bg-[#EBE8FF] text-black"
                      : "bg-white border border-[#E2E2E2] text-gray-800"
                  } p-3 rounded-lg max-w-xs w-full`}
                >
                  {msg.file ? (
                    <div className="flex items-center space-x-2">
                      <Paperclip className="w-4 h-4 text-gray-600" />
                      <span className="text-sm font-semibold">{msg.file}</span>
                      <span className="text-xs text-gray-500">
                        ({msg.size})
                      </span>
                    </div>
                  ) : (
                    <p className="text-sm">{msg.text}</p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Input Area */}
        <div className="p-4 border-t border-gray-200 flex items-center space-x-2">
          <button>
            <Paperclip className="w-5 h-5 text-gray-600" />
          </button>
          <input
            type="text"
            placeholder="Send a message"
            className="flex-1 border border-gray-300 rounded-lg px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-purple-500"
          />
          <button onClick={() => handleSendMessage("Test message")}>
            <Send className="w-5 h-5 text-purple-600" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChatVendor;
